import api from '@/api'

export default {
  createEmailTemplate(template) {
    return new Promise(function (resolve, reject) {
      const url = `/api/v1/email/template`
      api
        .request('post', url, true, template)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  saveEmailTemplate(templateId, template) {
    return new Promise(function (resolve, reject) {
      const url = `/api/v1/email/template/${templateId}`
      api
        .request('put', url, true, template)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  getAllEmailTemplates() {
    return new Promise(function (resolve, reject) {
      const url = `/api/v1/email/template`
      api
        .request('get', url, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Campaign/EmailTemplateAPIs.js